import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={10} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <rect width="10" height="10" rx="1" fill="#FF0000" />
    <g clipPath="url(#clip0_6809_157538)">
      <path
        d="M2.14307 5.71596L4.22099 7.85882C5.19878 5.05004 6.0131 3.81751 7.85735 2.14453"
        stroke="white"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6809_157538">
        <rect width="8" height="8" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const StatusDeliveryLate = memo(ForwardRef);
export default StatusDeliveryLate;
